module.exports = __webpack_public_path__ + "speech_bubble.cdb28b8ede307cd16e9ada36bf89dee3.svg";